import React from 'react';
import { useTranslation } from 'react-i18next';
import { formNamesService } from '../../../services/formNamesService';
import ListItemTitle from '../../../shared/ListItemTitle';
import DeleteItemIcon from '../../../shared/DeleteItemIcon';
import { formDeleteService } from '../../../services/formDeleteService';
import { POPUP_KEY_DELETE_FORM, POPUP_KEY_RESTORE_FORM } from '../../../constant';
import RestoreItemIcon from '../../../shared/RestoreItemIcon';
import EditItemIcon from '../../../shared/EditItemIcon';

const FormsListItem = ({ form }) => {
    const { i18n } = useTranslation();
    return (
        <>
            <ListItemTitle itemCode={form} itemService={formNamesService}/>
            <h3 className="main__subtitle product__list-code">{form.productForm}</h3>
            <h2 className="block__content product__list-title">{i18n.t('app.page.product.addFormItem.formGroup')}</h2>
            <p className="block__content product__list-content">
                {form.formGroup ?
                    i18n.t(`product.scheme.formGroup.${form.formGroup}`)
                    :
                    <span className="product__list-content_warning">{i18n.t('app.page.product.notAssigned')}</span>
                }
            </p>
            <h2 className="block__content product__list-title">{i18n.t('app.page.product.addFormItem.formType')} </h2>
            <p className="block__content product__list-content">
                {form.formType ?
                    i18n.t(`product.scheme.formType.${form.formType}`)
                    :
                    <span className="product__list-content_warning">{i18n.t('app.page.product.notAssigned')}</span>
                }
            </p>
            <div className="product__list-icons">
                {form.isDeleted ?
                    <RestoreItemIcon itemId={form.id} popupKey={POPUP_KEY_RESTORE_FORM} />
                    :
                    <EditItemIcon pageUrl={`/product/form/${form.id}/`}/>}
                <DeleteItemIcon 
                    itemId={form.id} 
                    itemDeleteService={formDeleteService} 
                    popupKey={POPUP_KEY_DELETE_FORM} 
                />
            </div>
        </>
    );
};

export default FormsListItem;
